import { useGetOptions } from 'hooks/useGetOptions';
import { useGetEmployersForSelect } from 'queries';

export const useGetEmployerOptions = () => {
  const { data, isError } = useGetEmployersForSelect();

  return useGetOptions(data ?? [], isError, 'employerId', 'name');
};
